import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=9967be4c&scoped=true"
import script from "./CarList.vue?vue&type=script&lang=ts"
export * from "./CarList.vue?vue&type=script&lang=ts"
import style0 from "./CarList.vue?vue&type=style&index=0&id=9967be4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9967be4c",
  null
  
)

export default component.exports